// Bun inlines `process.env.BUN_PUBLIC_*` at build time only when the variable
// is set; an unset one is left as-is and `process` does not exist in the
// browser. Read each through a guard so an unset variable falls back.
function publicEnv(read: () => string | undefined): string | undefined {
	try {
		return read() || undefined;
	} catch {
		return undefined;
	}
}

const apiBaseURL =
	publicEnv(() => process.env.BUN_PUBLIC_API_BASE_URL) ?? "/v1";
const appURL = (
	publicEnv(() => process.env.BUN_PUBLIC_APP_URL) ??
	"https://app.obratododia.com.br"
).replace(/\/+$/, "");

export default {
	api: { baseURL: apiBaseURL },
	app: { url: appURL, waitlistURL: `${appURL}/onboarding` },
};
